import { refreshTokenHandler, setLocaleHeader } from '@brightdrop/auth-client';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const defaultUrlForTesting = 'http://localhost:3000';

export const emptyApi = createApi({
  refetchOnMountOrArgChange: 10,
  baseQuery: fetchBaseQuery({
    baseUrl: `${globalThis.appConfig.apiBaseUrl || defaultUrlForTesting}`,
    prepareHeaders: async (headers) => {
      const response = await refreshTokenHandler();
      const { accessToken: token } = response ?? {};
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      setLocaleHeader(headers);

      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'rtkClient',
});
